module.exports = __webpack_public_path__ + "static/media/group-9@2x.52c440dd.png";